// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"0198abc7","571":"bb183e4a","950":"3eaa3b97"}[chunkId] + ".chunk.css";
};